import { isValidPhoneNumber } from 'libphonenumber-js'

/**
 * Validates if a phone number is valid using libphonenumber-js
 * @param phoneNumber - The phone number to validate (can be null/undefined)
 * @returns boolean - true if valid or empty, false if invalid
 */
export const isPhoneNumberValid = (phoneNumber: string | null | undefined): boolean => {
  if (!phoneNumber) return true
  return isValidPhoneNumber(phoneNumber)
}
